import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

export default function OFEDashboard() {
  const { user } = useAuth();
  const { data: health, loading } = useOFEFetch('/ofe/health', user);

  const tiles = [
    { label: 'Production Planner', href: '/ofe/production/project/ALL', icon: '📋', desc: 'Per-unit tracker across all vendors' },
    { label: 'Vendor Directory', href: '/ofe/vendors', icon: '🏭', desc: '20–25 key equipment vendors' },
    { label: 'Programs & BOM', href: '/ofe/programs', icon: '📐', desc: 'Design requirements and BOM by MW' },
    { label: 'Reallocations', href: '/ofe/reallocations', icon: '🔄', desc: 'Inter-project equipment reallocation' },
    { label: 'Financial Tracker', href: '/ofe/financials', icon: '💰', desc: 'Oracle POs, JE proposals, exposure' },
    { label: 'Storage Locations', href: '/ofe/storage', icon: '🏗️', desc: 'Warehouses, yards, 3PL locations' },
    { label: 'Shipment Tracker', href: '/ofe/shipments', icon: '🚚', desc: 'In-transit and receiving status' },
    { label: 'Cx Look-Ahead', href: '/ofe/cx', icon: '✅', desc: 'Commissioning milestones and issues' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">OFE Dashboard</h1>
          <p className="text-gray-400 mt-1">Owner Furnished Equipment — lifecycle management for hyperscale DC construction</p>
        </div>
        {health && (
          <div className="text-sm text-gray-400">
            <span className="text-green-400 font-semibold">{health.vendors}</span> vendors ·{' '}
            <span className="text-blue-400 font-semibold">{health.production_items}</span> items tracked
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {tiles.map(t => (
          <Link key={t.href} to={t.href}
            className="bg-gray-800 border border-gray-700 rounded-lg p-4 hover:border-blue-500 transition-colors group">
            <div className="text-3xl mb-2">{t.icon}</div>
            <div className="text-white font-semibold group-hover:text-blue-400">{t.label}</div>
            <div className="text-gray-400 text-xs mt-1">{t.desc}</div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-4">
        <Link to="/ofe/cx/issues" className="bg-red-900/20 border border-red-800 rounded-lg p-4 hover:bg-red-900/30">
          <div className="text-red-400 font-semibold">Cx Issues</div>
          <div className="text-gray-400 text-sm mt-1">Open commissioning issues requiring attention</div>
        </Link>
        <Link to="/ofe/reallocations/new" className="bg-yellow-900/20 border border-yellow-800 rounded-lg p-4 hover:bg-yellow-900/30">
          <div className="text-yellow-400 font-semibold">Propose Reallocation</div>
          <div className="text-gray-400 text-sm mt-1">Move equipment between projects</div>
        </Link>
        <Link to="/ofe/financials/je" className="bg-purple-900/20 border border-purple-800 rounded-lg p-4 hover:bg-purple-900/30">
          <div className="text-purple-400 font-semibold">JE Review Queue</div>
          <div className="text-gray-400 text-sm mt-1">Journal entry proposals awaiting Finance</div>
        </Link>
      </div>
    </div>
  );
}
